import { useDispatch, useSelector } from 'react-redux'
import CardDetails from './CardDetails'
import { useEffect } from 'react'
import fetchData from '../../service/apiService'
import {
  cleanTopics,
  clone,
  getEndpointFromConfig,
} from '../../common/utils/helper'
import { endpointLabels, featureType } from '../../common/utils/enum'
import { useState } from 'react'
import { setCountryDropdownValue, setModalHandled } from './themeProfileSlice'
import FeaturedDatasets from '../../common/components/FeaturedDatasets'
import CountryAnalytics from '../../common/components/CountryAnalytics'
import MessageModal from '../../common/components/MessageModal'
import InsightAndResource from '../../common/components/InsightAndResource'
import FeaturedGlobalReports from '../../common/components/FeaturedGlobalReports'

const ThemeWrapper = ({
  selector,
  apiKeyName,
  apiKeyValue,
  downloadPath,
  dataSourceRedirectURLAuthor,
  dataSourceRedirectURLPublish,
  publishIndicatorLink,
  authorIndicatorLink,
  publishTopicLink,
  authorTopicLink,
  searchURLPublish,
  searchURLAuthor,
  mode,
}) => {
  const [themeHierarchyData, setThemeHierarchy] = useState({})
  const dispatch = useDispatch()

  const endpointList = useSelector((state) => state.common['endpointList'])
  const hierarchyData = useSelector((state) => state.common['hierarchyData'])
  const [datasetDetails, setDatasetDetails] = useState([])

  const environment = mode
  let redirectURL = ''
  let topicRedirectUrl,
    searchRedirectUrl,
    indicatorRedirectUrl = ''
  if (mode === 'publish') {
    topicRedirectUrl = `${publishTopicLink}/`
    indicatorRedirectUrl = `${publishIndicatorLink}/`
    searchRedirectUrl = `${searchURLPublish}`
    redirectURL = dataSourceRedirectURLPublish
  } else {
    topicRedirectUrl = `${authorTopicLink}.`
    indicatorRedirectUrl = `${authorIndicatorLink}.`
    redirectURL = dataSourceRedirectURLAuthor
    searchRedirectUrl = `${searchURLAuthor}.html`
  }

  useEffect(() => {
    const handleDropdownChange = (event) => {
      dispatch(setCountryDropdownValue(event.detail))
    }

    window.addEventListener('dropdownChange', handleDropdownChange)

    return () => {
      window.removeEventListener('dropdownChange', handleDropdownChange)
    }
  }, [])

  const themeId = hierarchyData?.codes?.find(
    (hd) => hd?.id?.toLowerCase() === selector?.toLowerCase()
  )

  useEffect(() => {
    if (themeHierarchyData?.value) {
      const topicTag = themeHierarchyData?.value
      // set topicTag in wbgData
      let wbgData = window.wbgData
      if (typeof wbgData !== 'undefined') {
        wbgData.page = wbgData.page || {}
        wbgData.page.pageInfo = wbgData.page.pageInfo || {}
        wbgData.page.pageInfo.topicTag = topicTag

        const _satellite = window._satellite || {}
        if (
          typeof _satellite !== 'undefined' &&
          typeof _satellite.track === 'function'
        ) {
          _satellite.track('dynamicdata')
        }
      }
    }
  }, [themeHierarchyData])

  // const filterFeaturedDataset = `type eq 'dataset' and series_description/topics/any(t2: (t2/name eq '${themeId}'))`
  const filterFeaturedDataset = `type eq 'dataset' and tags/any(t3: (t3/tag_group eq 'feature-theme-profile')) and tags/any(t3: (t3/tag eq '${selector.toUpperCase()}'))`
  useEffect(() => {
    const fetchMetaData = async (themeHierarchyObject) => {
      let filterString = themeHierarchyObject?.topicList
        ?.flatMap(
          (topicDetail) =>
            topicDetail.subTopics?.flatMap((subTopicDetail) =>
              subTopicDetail.indicators?.map(
                (indicatorDetail) =>
                  `series_description/idno eq '${indicatorDetail.id}'`
              )
            ) ?? []
        )
        .filter(Boolean)
        .join(' or ')
      try {
        const request = {
          count: true,
          facets: [],
          orderby: '',
          select:
            'series_description/idno, series_description/database_id, series_description/database_name, series_description/definition_long, series_description/name, series_description/time_periods,series_description/ref_country,additional/visualization,series_description/sources',
          searchFields: '',
          search: '*',
          top: 1000,
          skip: 0,
          filter: filterString,
        }
        const headers = apiKeyName
          ? {
              [apiKeyName]: apiKeyValue,
            }
          : undefined
        const metadataResponse = await fetchData(
          getEndpointFromConfig(endpointList, endpointLabels.Metadata)
            .apiEndpoint,
          'POST',
          request,
          headers
        )
        let indicatorList = []
        if (
          metadataResponse &&
          metadataResponse.value &&
          metadataResponse.value.length > 0
        ) {
          metadataResponse.value.forEach((obj) => {
            const idno = obj.series_description.idno
            const definition_long = obj.series_description.definition_long
            const database_id = obj.series_description.database_id
            const database_name = obj.series_description.database_name
            const name = obj?.additional?.visualization?.display_name
              ? obj.additional.visualization.display_name
              : obj.series_description.name
            let years,
              economies = '',
              visualization = null
            if (
              obj.series_description.time_periods &&
              obj.series_description.time_periods.length > 0
            ) {
              years = `${obj.series_description.time_periods[0].start}-${obj.series_description.time_periods[0].end}`
            }
            if (obj.series_description.ref_country) {
              economies = obj.series_description.ref_country.length
            }
            if (obj.additional && obj.additional.visualization) {
              visualization = obj.additional.visualization
            }
            let sources = []
            if (
              obj?.series_description?.sources &&
              obj?.series_description?.sources.length > 0
            ) {
              sources = obj?.series_description?.sources.map((item) => {
                return {
                  source: item.name
                    ? item.organization
                      ? `${item.name}, ${item.organization}`
                      : item.name
                    : item.organization,
                  sourceLink: item.uri,
                }
              })
            }
            // Function to recursively search and update the indicators
            const updateIndicators = (topic) => {
              topic.subTopics.forEach((subTopic) => {
                subTopic.isSelectedSubTopic = false
                subTopic.indicators.forEach((indicator) => {
                  if (indicator?.charts?.theme === null) {
                    return
                  }
                  if (indicator.id === idno) {
                    indicator.longDefination = definition_long
                    indicator.datasetId = database_id
                    indicator.datasetName = database_name
                    indicator.name = name
                    indicator.isSelected = false
                    indicator.years = years
                    indicator.economies = economies
                    indicator.visualization = visualization
                    indicator.sources = sources
                  }
                })
                if (subTopic.subTopics) {
                  updateIndicators(subTopic.subTopics)
                }
              })
            }
            themeHierarchyObject.topicList.forEach((topic) => {
              updateIndicators(topic)
            })
            themeHierarchyObject?.topicList?.map((topics) => {
              topics.subTopics[0].isSelectedSubTopic = true
              topics.subTopics[0].indicators[0].isSelected = true
              // topics.subTopics.forEach((obj) => {
              //   obj.indicators[0].isSelected = true
              // })
            })
          })
          setThemeHierarchy(themeHierarchyObject)

          const datasetIds = metadataResponse?.value?.map(
            (obj) => obj?.series_description?.database_id
          )
          // fetchDatasetDetails(datasetIds)
        }
      } catch (error) {
        console.error('Error fetching metadata:', error)
      }
    }
    if (hierarchyData?.codes?.length) {
      let tempHierarchyData = hierarchyData?.codes?.find(
        (obj) => obj.id.toLowerCase() === selector.toLowerCase()
      )
      tempHierarchyData = clone(tempHierarchyData)
      tempHierarchyData.codes.forEach((item) => {
        item.subTopics = item.codes
        delete item.codes
      })

      let themeHierarchyObject = {
        id: tempHierarchyData.id,
        value: tempHierarchyData.value,
        topicList: tempHierarchyData.codes,
      }
      themeHierarchyObject.topicList = cleanTopics(
        themeHierarchyObject.topicList
      )
      fetchMetaData(themeHierarchyObject)
    }
  }, [hierarchyData?.codes])

  // const fetchDatasetDetails = async (datasetIds) => {
  //   try {
  //     const filterString = datasetIds
  //       .map(
  //         (id) =>
  //           `type eq 'dataset' and series_description/database_id eq '${id}'`
  //       )
  //       .join(' or ')

  //     const request = {
  //       count: true,
  //       facets: [],
  //       orderby: 'series_description/date_last_update desc',
  //       select:
  //         'series_description/economies_count, series_description/database_id, metadata_information/title, series_description/time_periods',
  //       filter: filterString,
  //     }

  //     const headers = apiKeyName ? { [apiKeyName]: apiKeyValue } : undefined
  //     const datasetResponse = await fetchData(
  //       getEndpointFromConfig(endpointList, endpointLabels.Metadata)
  //         .apiEndpoint,
  //       'POST',
  //       request,
  //       headers
  //     )

  //     if (datasetResponse?.value?.length > 0) {
  //       setDatasetDetails(datasetResponse?.value)
  //     }
  //   } catch (error) {
  //     console.error('Error fetching dataset details:', error)
  //   }
  // }

  // const handleIndicatorChange = (topicId, indicatorId) => {
  //   if (!topicId || !indicatorId) return

  //   const tempThemeData = clone(themeHierarchyData)
  //   const topic = tempThemeData.topicList.find((obj) => obj.topicId === topicId)

  //   if (topic) {
  //     topic.indicators = topic.indicators.map((indicator) => ({
  //       ...indicator,
  //       isSelected: indicator.id === indicatorId,
  //     }))

  //     setThemeHierarchy(tempThemeData)
  //   }
  // }

  return (
    <>
      <div className="aem-GridColumn--xs--12 aem-GridColumn--phone--12 aem-GridColumn--tablet--12 aem-GridColumn--desktop--12 aem-GridColumn--default--12">
        <div className="teaser">
          <div className="cmp-teaser">
            <div className="cmp-teaser__content">
              <h2 className="cmp-teaser__title">
                Topics in{' '}
                {`${
                  themeHierarchyData?.value ? themeHierarchyData?.value : ''
                }`}
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container responsivegrid  aem-GridColumn--xs--12 aem-GridColumn--phone--12 aem-GridColumn--tablet--12 aem-GridColumn--desktop--12 aem-GridColumn--default--12">
        <div className="cmp-container tui_flexcard_wrapper">
          {themeHierarchyData?.topicList?.map((obj, index) => {
            return (
              <CardDetails
                key={`${index}-${obj.id}`}
                topicObj={obj}
                // handleIndicatorChange={handleIndicatorChange}
                redirectURL={redirectURL}
                environment={environment}
                topicRedirectUrl={topicRedirectUrl}
                indicatorRedirectUrl={indicatorRedirectUrl}
                featuredDatasetsData={datasetDetails}
                searchRedirectUrl={searchRedirectUrl}
              />
            )
          })}
        </div>
      </div>
      <FeaturedDatasets
        filterFeaturedDataset={filterFeaturedDataset}
        themeId={themeId?.value}
        pageName={'themeProfile'}
      />
      <CountryAnalytics themeName={themeHierarchyData?.value} />

      <FeaturedGlobalReports
        themeId={themeId?.id}
        pageName={featureType.ThemeProfile}
      />
      <InsightAndResource
        themeId={themeId?.id}
        pageName={featureType.ThemeProfile}
      />
    </>
  )
}

export default ThemeWrapper
